import { sagaEffects } from '../../dependencies';

import setPageSearchParam from './setPageSearchParam';

const { all } = sagaEffects;

export default function*() {
    yield all([setPageSearchParam()]);
}
